import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { customerOrdersTypes } from 'actions/types'

const initialState = []
const baseType = customerOrdersTypes.FETCH_CUSTOMER_ORDERS

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
